export default __webpack_public_path__ + "static/media/calendar-next.96fcf771.svg";